/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
// import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import BubbleChart from "@material-ui/icons/BubbleChart";
import PrintIcon from "@material-ui/icons/Print";
import SyncIcon from "@material-ui/icons/Sync";
// import LocationOn from "@material-ui/icons/LocationOn";
// import Notifications from "@material-ui/icons/Notifications";
import Unarchive from "@material-ui/icons/Unarchive";
// import Language from "@material-ui/icons/Language";
// core components/views for Admin layout
// import DashboardPage from "views/Dashboard/Dashboard.js";
//import UserProfile from "views/UserProfile/UserProfile.js";
import StockCountJobContainer from "views/StockJobs/StockJobContainer";
import UserContainer from "views/UserManagement/UserContainer";
import RoleContainer from "views/RoleManagement/RoleContainer";
import PrinterContainer from "views/PrinterManagement/PrinterContainer";
import SyncContainer from "views/Sync/SyncContainer";
import Ixanos from "views/ixanos";
// import TableList from "views/TableList/TableList.js";
// import Typography from "views/Typography/Typography.js";
// import Icons from "views/Icons/Icons.js";
// import Maps from "views/Maps/Maps.js";
// import NotificationsPage from "views/Notifications/Notifications.js";
//import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.js";
// core components/views for RTL layout
//import RTLPage from "views/RTLPage/RTLPage.js";

const dashboardRoutes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   rtlName: "لوحة القيادة",
  //   icon: Dashboard,
  //   component: DashboardPage,
  //   layout: "/portal",
  // },
  {
    path: "/stockCounts",
    name: "Stock Counts",
    icon: LibraryBooks,
    component: StockCountJobContainer,
    adminOnly: false,
    layout: "/portal",
  },
  {
    path: "/user",
    name: "User Management",
    icon: Person,
    component: UserContainer,
    adminOnly: true,
    layout: "/portal",
  },
  {
    path: "/role",
    name: "Role Management",
    icon: BubbleChart,
    component: RoleContainer,
    adminOnly: true,
    layout: "/portal",
  },
  {
    path: "/printer",
    name: "Printer Management",
    icon: PrintIcon,
    component: PrinterContainer,
    adminOnly: true,
    layout: "/portal",
  },
  {
    path: "/sync",
    name: "Sync",
    icon: SyncIcon,
    component: SyncContainer,
    adminOnly: true,
    layout: "/portal",
  },
  // {
  //   path: "/table",
  //   name: "Table List",
  //   rtlName: "قائمة الجدول",
  //   icon: "content_paste",
  //   component: TableList,
  //   layout: "/portal",
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   rtlName: "طباعة",
  //   icon: LibraryBooks,
  //   component: Typography,
  //   layout: "/portal",
  // },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   rtlName: "الرموز",
  //   icon: BubbleChart,
  //   component: Icons,
  //   layout: "/portal",
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   rtlName: "خرائط",
  //   icon: LocationOn,
  //   component: Maps,
  //   layout: "/portal",
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   rtlName: "إخطارات",
  //   icon: Notifications,
  //   component: NotificationsPage,
  //   layout: "/portal",
  // },
  // {
  //   path: "/rtl-page",
  //   name: "RTL Support",
  //   rtlName: "پشتیبانی از راست به چپ",
  //   icon: Language,
  //   component: RTLPage,
  //   layout: "/rtl",
  // },
  // {
  //   path: "/upgrade-to-pro",
  //   name: "Upgrade To PRO",
  //   rtlName: "التطور للاحترافية",
  //   icon: Unarchive,
  //   component: UpgradeToPro,
  //   layout: "/portal",
  // },
  {
    path: "/ixanos",
    name: "Powered by Ixanos",
    icon: Unarchive,
    component: Ixanos,
    layout: "/portal",
  },
];

export default dashboardRoutes;
